import React from 'react';

import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Equipment/components/FormField';

const NameField = () => {
  return (
    <div data-testid="equipment-item-name">
      <FormField label="Name *" htmlFor="name">
        <FormikInput id="name" name="name" />
      </FormField>
    </div>
  );
};

export default NameField;
